const API_URL = process.env.REACT_APP_API_URL;

export async function apiFetch(
  input: RequestInfo,
  init: RequestInit = {}
): Promise<Response> {
  const res = await fetch(input, {
    ...init,
    credentials: "include",
  });

  if (res.status === 401) {
    // spróbuj odświeżyć sesję
    await fetch(`${API_URL}/auth/status`, {
      credentials: "include",
    });

    // retry
    return fetch(input, {
      ...init,
      credentials: "include",
    });
  }

  return res;
}
